module.exports = __webpack_public_path__ + "static/media/fundsSubscriptionInProgress.0492979d.svg";